<script lang="ts">
	///// Order here is critical, as otherwise ui-lib styles should override app styles.
	///// Please don't change this code, if you not sure, what is exact reason to do it.
	///// Order here is critical, as otherwise ui-lib styles should override app styles.
	import { QueryClientProvider } from '@tanstack/svelte-query';
	import { locale, ToastComponent } from '@cf/ui-lib';
	import { userStore } from '../context/slices/user.slice';

	import Header from '$lib/components/layout/header.svelte';
	import type { LayoutData } from './$types';

	import './app.css';

	export let data: LayoutData;

	// Initialize user store when data changes
	$: if (data?.userInfo) {
		userStore.setUser(data.userInfo);
	}

	locale.set('en');
</script>

<QueryClientProvider client={data.queryClient}>
	<div class="flex h-screen flex-col">
		<Header userInfo={data?.userInfo} />
		<ToastComponent />
		<main class="h-[calc(100%-63px)] flex-1 overflow-y-auto bg-light">
			<slot />
		</main>
	</div>
</QueryClientProvider>
